(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["callie-ai-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.clai-menu').forEach(function(menu){
    var menuShell=menu.closest('[data-clai-header]');
    var desktopTrigger=menuShell?menuShell.querySelector('[data-clai-desktop-toggle]'):null;
    var homeLink=menu.querySelector('[data-clai-home-link]');
    var tabStrip=menu.querySelector('.clai-drawer__tabs');
    if(homeLink){
      homeLink.addEventListener('click',function(event){
        var destination=new URL(homeLink.href,window.location.href);
        if(window.location.pathname===destination.pathname && window.location.search===destination.search && window.location.hash===destination.hash){
          event.preventDefault();
          window.location.reload();
        }
      });
    }
    function closeMenu(){
      menu.removeAttribute('open');
      document.body.classList.remove('clai-menu-open');
      if(desktopTrigger && window.matchMedia('(min-width:1101px)').matches) desktopTrigger.focus({preventScroll:true});
    }
    var drawerElement=menu.querySelector('.clai-drawer');
    var outsideBackdrop=menu.querySelector('.clai-menu-backdrop');
    var outsideGestureStart=null;
    if(outsideBackdrop){
      outsideBackdrop.addEventListener('touchstart',function(event){
        if(!menu.open||!event.touches.length)return;
        outsideGestureStart={x:event.touches[0].clientX,y:event.touches[0].clientY};
      },{passive:true});
      outsideBackdrop.addEventListener('touchmove',function(event){
        if(!menu.open||!outsideGestureStart||!event.touches.length)return;
        var deltaX=event.touches[0].clientX-outsideGestureStart.x;
        var deltaY=event.touches[0].clientY-outsideGestureStart.y;
        if(Math.abs(deltaX)>18||Math.abs(deltaY)>18){
          outsideGestureStart=null;
          closeMenu();
        }
      },{passive:true});
      outsideBackdrop.addEventListener('touchend',function(){outsideGestureStart=null;},{passive:true});
      outsideBackdrop.addEventListener('touchcancel',function(){outsideGestureStart=null;},{passive:true});
      outsideBackdrop.addEventListener('wheel',function(event){
        if(menu.open&&(Math.abs(event.deltaY)>3||Math.abs(event.deltaX)>3))closeMenu();
      },{passive:true});
    }
    var previousPageScroll=window.scrollY;
    window.addEventListener('scroll',function(){
      var newPageScroll=window.scrollY;
      if(menu.open&&Math.abs(newPageScroll-previousPageScroll)>4){
        if(!drawerElement||!drawerElement.matches(':hover'))closeMenu();
      }
      previousPageScroll=newPageScroll;
    },{passive:true});
    if(desktopTrigger){
      desktopTrigger.addEventListener('click',function(){
        if(menu.open){closeMenu();return;}
        menu.setAttribute('open','');
        var closeButton=menu.querySelector('.clai-drawer__close');
        if(closeButton) closeButton.focus({preventScroll:true});
      });
    }

    menu.querySelectorAll('[data-clai-group-target]').forEach(function(title){
      var destination=title.getAttribute('data-clai-group-target');
      var tapAt=0;
      title.addEventListener('dblclick',function(event){event.preventDefault();window.location.assign(destination);});
      title.addEventListener('touchend',function(event){
        var now=Date.now();
        if(now-tapAt<350){event.preventDefault();window.location.assign(destination);}else{tapAt=now;}
      },{passive:false});
    });
    var categoryTabs=Array.prototype.slice.call(menu.querySelectorAll('[data-clai-tab]'));
    var categoryPanels=Array.prototype.slice.call(menu.querySelectorAll('[data-clai-panel]'));
    function selectCategory(tab,moveFocus){
      var panelId=tab.getAttribute('aria-controls');
      if(homeLink){
        homeLink.classList.remove('is-active');
        homeLink.setAttribute('aria-selected','false');
      }
      categoryTabs.forEach(function(item){
        var active=item===tab;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-selected',active?'true':'false');
        item.tabIndex=active?0:-1;
      });
      categoryPanels.forEach(function(panel){panel.hidden=panel.id!==panelId;});
      if(tabStrip && tabStrip.scrollWidth>tabStrip.clientWidth){
        var tabRect=tab.getBoundingClientRect();
        var stripRect=tabStrip.getBoundingClientRect();
        var centered=tabStrip.scrollLeft+tabRect.left-stripRect.left-(stripRect.width-tabRect.width)/2;
        tabStrip.scrollTo({left:Math.max(0,centered),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }
      if(moveFocus)tab.focus({preventScroll:true});
    }
    categoryTabs.forEach(function(tab,index){
      tab.addEventListener('click',function(){selectCategory(tab,false);});
      tab.addEventListener('keydown',function(e){
        var nextIndex=index;
        if(e.key==='ArrowRight')nextIndex=(index+1)%categoryTabs.length;
        else if(e.key==='ArrowLeft')nextIndex=(index-1+categoryTabs.length)%categoryTabs.length;
        else if(e.key==='Home')nextIndex=0;
        else if(e.key==='End')nextIndex=categoryTabs.length-1;
        else return;
        e.preventDefault();
        selectCategory(categoryTabs[nextIndex],true);
      });
    });
    menu.addEventListener('toggle',function(){
      document.body.classList.toggle('clai-menu-open',menu.open);
      if(desktopTrigger) desktopTrigger.setAttribute('aria-expanded',menu.open?'true':'false');
    });
    menu.querySelectorAll('[data-clai-close]').forEach(function(button){
      button.addEventListener('click',closeMenu);
    });
    menu.addEventListener('keydown',function(event){
      if(event.key==='Escape')closeMenu();
    });
  });
})();

(function(){
  function initCallieHomeScrollHeader(){
    var shell=document.querySelector('.clai-home-header[data-clai-header]');
    if(!shell||shell.dataset.claiScrollReady==='true')return;
    var host=shell.closest('.shopify-section');
    if(!host)return;
    shell.dataset.claiScrollReady='true';
    var spacer=document.createElement('div');
    spacer.className='clai-home-header-spacer';
    spacer.setAttribute('aria-hidden','true');
    host.insertAdjacentElement('afterend',spacer);
    function measure(){
      spacer.style.height=Math.ceil(shell.getBoundingClientRect().height)+'px';
    }
    measure();
    host.classList.add('clai-home-header-host');
    if('ResizeObserver' in window){
      new ResizeObserver(measure).observe(shell);
    }
    window.addEventListener('resize',measure,{passive:true});
    var lastY=Math.max(0,window.scrollY||0);
    var down=0,up=0,ticking=false;
    function update(){
      ticking=false;
      var y=Math.max(0,window.scrollY||0);
      var d=y-lastY;
      if(d>0){down+=d;up=0}
      else if(d<0){up-=d;down=0}
      var drawerOpen=!!shell.querySelector('.clai-menu[open]');
      if(y<=8||drawerOpen){
        host.classList.remove('is-clai-scroll-hidden');
        down=0;up=0;
      }else if(up>=12){
        host.classList.remove('is-clai-scroll-hidden');
        up=0;
      }else if(y>Math.max(120,spacer.offsetHeight+18)&&down>=18&&!(shell.contains(document.activeElement)&&document.activeElement.matches(':focus-visible'))){
        host.classList.add('is-clai-scroll-hidden');
        down=0;
      }
      lastY=y;
    }
    window.addEventListener('scroll',function(){
      if(!ticking){ticking=true;window.requestAnimationFrame(update)}
    },{passive:true});
    shell.addEventListener('focusin',function(){host.classList.remove('is-clai-scroll-hidden')});
    var drawer=shell.querySelector('.clai-menu');
    if(drawer)drawer.addEventListener('toggle',function(){
      if(drawer.open)host.classList.remove('is-clai-scroll-hidden');
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initCallieHomeScrollHeader);
  }else{
    initCallieHomeScrollHeader();
  }
  document.addEventListener('shopify:section:load',initCallieHomeScrollHeader);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["callie-ai-hero-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(hero){
    if(!hero||hero.dataset.claiHeroInitialized==='1')return;
    hero.dataset.claiHeroInitialized='1';
    var rail=hero.querySelector('.clai-hero__rail');
    var slides=Array.prototype.slice.call(hero.querySelectorAll('[data-clai-hero-slide]'));
    var dots=Array.prototype.slice.call(hero.querySelectorAll('[data-clai-hero-dot]'));
    if(!rail||!slides.length)return;
    var current=0,timer=null,scrollFrame=null;
    var allowAutoplay=hero.dataset.claiAutoplay==='true'&&slides.length>1&&!(window.Shopify&&window.Shopify.designMode)&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var delay=Math.max(3000,Number(hero.dataset.claiDelay||6)*1000);
    function render(){
      dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===current);if(i===current){dot.setAttribute('aria-current','true')}else{dot.removeAttribute('aria-current')}});
    }
    function go(i){
      current=(i+slides.length)%slides.length;
      rail.scrollTo({left:slides[current].offsetLeft-slides[0].offsetLeft,behavior:'smooth'});
      render();
    }
    function stop(){if(timer!==null){clearInterval(timer);timer=null;}}
    function start(){if(allowAutoplay&&!timer)timer=setInterval(function(){go(current+1)},delay);}
    dots.forEach(function(dot,i){dot.addEventListener('click',function(){go(i);stop();start()})});
    var prev=hero.querySelector('[data-clai-hero-prev]'),next=hero.querySelector('[data-clai-hero-next]');
    if(prev)prev.addEventListener('click',function(){go(current-1);stop();start()});
    if(next)next.addEventListener('click',function(){go(current+1);stop();start()});
    rail.addEventListener('scroll',function(){
      if(scrollFrame!==null)return;
      scrollFrame=window.requestAnimationFrame(function(){
        scrollFrame=null;
        var w=rail.clientWidth||1;
        current=Math.max(0,Math.min(slides.length-1,Math.round(rail.scrollLeft/w)));
        render();
      });
    },{passive:true});
    hero.addEventListener('mouseenter',stop);
    hero.addEventListener('mouseleave',start);
    hero.addEventListener('focusin',stop);
    hero.addEventListener('focusout',function(){window.requestAnimationFrame(function(){if(!hero.contains(document.activeElement))start()})});
    document.addEventListener('shopify:section:unload',function(e){if(e.target.contains(hero))stop()});
    document.addEventListener('shopify:block:select',function(e){var slide=e.target.closest('[data-clai-hero-slide]');if(slide&&hero.contains(slide)){stop();go(slides.indexOf(slide))}});
    render();start();
  }
  function initAll(){document.querySelectorAll('[data-clai-hero]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-welcome-popup"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.cl-welcome').forEach(function(dialog){
    var key='cl:welcome:'+dialog.id;
    var seen=parseInt(localStorage.getItem(key)||'0',10);
    var days=parseInt(dialog.dataset.days||'7',10);
    if(Date.now()-seen<days*86400000)return;
    var close=dialog.querySelector('.cl-welcome__close');
    function hide(){if(dialog.open)dialog.close();localStorage.setItem(key,String(Date.now()))}
    if(close)close.addEventListener('click',hide);
    dialog.addEventListener('cancel',function(e){e.preventDefault();hide()});
    setTimeout(function(){if(!dialog.open)dialog.showModal()},parseInt(dialog.dataset.delay||'6500',10));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-products"] && !Shopify.designMode) return;
  try {
    
(function(){
 function mount(root){
  const rails=[];
  if(root.matches&&root.matches('[data-st-rail]'))rails.push(root);
  if(root.querySelectorAll)rails.push(...root.querySelectorAll('[data-st-rail]'));
  rails.forEach(rail=>{
   if(rail.dataset.stDotsReady==='1')return;
   const track=rail.querySelector('[data-st-rail-track]');
   const dots=rail.querySelector('[data-st-rail-dots]');
   if(!track||!dots)return;
   rail.dataset.stDotsReady='1';
   let positions=[],buttons=[],raf=0;
   function active(){
    if(!buttons.length)return;
    let closest=0,dist=Infinity;
    positions.forEach((position,index)=>{let d=Math.abs(track.scrollLeft-position);if(d<dist){closest=index;dist=d}});
    buttons.forEach((button,index)=>{
      const on=index===closest;
      button.classList.toggle('is-active',on);
      button.setAttribute('aria-current',String(on));
      button.setAttribute('aria-pressed',String(on));
    });
   }
   function rebuild(){
    const items=Array.from(track.children).filter(item=>item.getClientRects().length);
    const max=Math.max(0,track.scrollWidth-track.clientWidth);
    const gap=parseFloat(getComputedStyle(track).columnGap)||0;
    const step=items.length?items[0].getBoundingClientRect().width+gap:0;
    const list=[0];
    if(max>3&&step>0){
      for(let i=1;i<items.length;i++){
        const target=Math.min(max,i*step);
        if(target-list[list.length-1]>3)list.push(target);
      }
      if(max-list[list.length-1]>3)list.push(max);
    }
    positions=list;
    buttons=[];
    dots.replaceChildren();
    dots.hidden=list.length<2;
    if(dots.hidden)return;
    list.forEach((position,i)=>{
      const button=document.createElement('button');
      button.type='button';
      button.className='st-edit-dot';
      button.setAttribute('aria-label','Scroll to product position '+(i+1)+' of '+list.length);
      button.addEventListener('click',()=>track.scrollTo({left:positions[i],behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));
      dots.append(button);
      buttons.push(button);
    });
    active();
   }
   track.addEventListener('scroll',()=>{
     if(raf)return;
     raf=requestAnimationFrame(()=>{raf=0;active()});
   },{passive:true});
   if(typeof ResizeObserver!=='undefined'){
     rail.stDotsResize=new ResizeObserver(rebuild);
     rail.stDotsResize.observe(track);
   }else window.addEventListener('resize',rebuild,{passive:true});
   rebuild();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});
 else mount(document);
 document.addEventListener('shopify:section:load',event=>mount(event.target));
 document.addEventListener('shopify:section:unload',event=>{
  const roots=event.target.matches&&event.target.matches('[data-st-rail]')?[event.target]:Array.from(event.target.querySelectorAll('[data-st-rail]'));
  roots.forEach(rail=>rail.stDotsResize?.disconnect());
 });
})();

  } catch(e) { console.error(e); }
})();
})();
